/**
 * @generated SignedSource<<4e409f27ab3ff6ee3bb0ab674939a40b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NavigationMenuQuery$variables = {
  influencerId: string;
};
export type NavigationMenuQuery$data = {
  readonly commentReadTimeTotal: {
    readonly unreadTotalComments: number;
  };
};
export type NavigationMenuQuery = {
  response: NavigationMenuQuery$data;
  variables: NavigationMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "influencerId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "influencerId",
    "variableName": "influencerId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreadTotalComments",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NavigationMenuQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CommentReadTimeTotal",
        "kind": "LinkedField",
        "name": "commentReadTimeTotal",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NavigationMenuQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CommentReadTimeTotal",
        "kind": "LinkedField",
        "name": "commentReadTimeTotal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ad1242e5f2f86fd6a4d1abf70f149a4e",
    "id": null,
    "metadata": {},
    "name": "NavigationMenuQuery",
    "operationKind": "query",
    "text": "query NavigationMenuQuery(\n  $influencerId: ID!\n) {\n  commentReadTimeTotal(influencerId: $influencerId) {\n    unreadTotalComments\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5684596f9c8ce5a13b6d30b7ebc16c08";

export default node;
